import React from "react";
import axios from "axios";

import { useRouteMatch, useHistory } from "react-router-dom";
// const history = useHistory();

// ------------------ context
// import Context from "../../context/filter-context";

export default {
  request(request) {
    // Axios.defaults.headers.get['Accepts'] = 'application/json, text/plain';
    // Axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    // Axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
    // Axios.defaults.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PUT, PATCH, DELETE, OPTIONS';
    return request;
  },

  requestError(error) {
    // Do something with request error

    return Promise.reject(error);
  },

  response(response) {
    // console.log('response JWT: ', response);

    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },

  responseError(error) {
    // if (error.response.status === 404) {
    //     if (!localStorage.getItem('token'))
    //         window.location.replace('/notfound');
    //     else
    //         window.location.replace('/user/notfound');

    // }

    // if (error.response.status === 404) {
    //   window.location.replace("/notfound");
    // }
    if (error.response.status === 500) {
      window.location.replace("/servererror");
    }
    if (error.response.status === 401) {
      localStorage.clear();
      window.location.replace("/");
    }

    return Promise.reject(error);
  },
};
